import React, { createContext } from 'react'
import { CellHeight, TableStickyProps } from './types'

export interface TableContextValues {
  cellHeight: CellHeight
  headCellHeight: CellHeight
  isNoCellRightBorders: boolean
  isTableLayoutFixed: boolean
  sticky?: TableStickyProps
}
export interface TableContextProviderProps {
  children: React.ReactNode | ((props: TableContextValues) => React.ReactNode)
  value: TableContextValues
}

export const tableContext = createContext<TableContextValues>({
  cellHeight: 'regular',
  headCellHeight: 'condensed',
  isTableLayoutFixed: false,
  isNoCellRightBorders: false,
})

export const TableContextProvider = ({ value, children }: TableContextProviderProps) => {
  return <tableContext.Provider value={value}>{children}</tableContext.Provider>
}
